import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const WELLEVATE_NEW_ACCOUNT_EMAIL_MUTATION = gql`
  mutation WellevateNewAccountEmail_UnauthenticatedWellevateAuthorize_Mutation(
    $input: wellevateNewAccountEmailInput!
  ) {
    wellevateNewAccountEmail(input: $input) {
      errors {
        message
      }
    }
  }
`;

interface WellevateNewAccountEmailData {
  wellevateNewAccountEmail: {
    errors: {
      message: string;
    };
  };
}

interface Variables {
  input: {
    email: string;
  };
}

const useWellevateNewAccountEmail = (
  options?: MutationHookOptions<WellevateNewAccountEmailData, Variables>
) =>
  useMutation<WellevateNewAccountEmailData, Variables>(
    WELLEVATE_NEW_ACCOUNT_EMAIL_MUTATION,
    options
  );

export {
  type WellevateNewAccountEmailData,
  useWellevateNewAccountEmail,
  WELLEVATE_NEW_ACCOUNT_EMAIL_MUTATION,
};
